import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-steppanels'
};

export default BaseStyle.extend({
    name: 'steppanels',
    classes
});
